import { Box, Card, Heading, SecurityShield } from '@ksyos/design-system';
import { useParams } from '@ksyos/router';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { translateKey } from '../../../translate';
import { ChangePassword } from './ChangePassword';
import { TwoFactorAuthenticationSettings } from './TwoFactorAuthenticationSettings';

export function SecuritySettings() {
    const { id: practitionerId } = useParams() as { id: string };
    const [security, setSecurity] = useState<'unsecure' | 'secure'>('unsecure');
    const currentUserId = useSelector((state: IReduxState) => state.authentication.id);
    const isOwnProfile = practitionerId === currentUserId;

    return (
        <>
            <Card>
                <Card.Body>
                    <Box
                        alignItems="center"
                        display="flex"
                        flexDirection="column"
                        gap={4}
                    >
                        <SecurityShield variant={security} />
                        <Heading size="xlarge">{translateKey('profile.security')}</Heading>
                    </Box>
                </Card.Body>
            </Card>
            <TwoFactorAuthenticationSettings
                isOwnProfile={isOwnProfile}
                onAppEnableChange={(value) => setSecurity(value ? 'secure' : 'unsecure')}
                practitionerId={practitionerId}
            />
            {isOwnProfile && <ChangePassword practitionerId={practitionerId} />}
        </>
    );
}
